const errors = {
  MESSAGE_LEN_SHORT: `Symptoms are not enough! Please give me more details...`,
};

export default errors;
